// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-fixed-bottom{position:fixed;bottom:0;right:0}.ellipsis{max-width:200px;margin-bottom:0}.case-notes{height:100%;-webkit-transform:translateX(0);transform:translateX(0)}.case-notes .ps{height:calc(100vh - 100px)}.v-timeline--dense:before{left:20px!important}.v-timeline--dense .v-timeline-item__body{max-width:calc(100% - 20px);margin-left:20px}.v-timeline--dense .v-timeline-item__divider{min-width:40px}", ""]);
// Exports
module.exports = exports;
